import { render, staticRenderFns } from "./Spkb.vue?vue&type=template&id=2c497f71&"
import script from "./Spkb.vue?vue&type=script&lang=js&"
export * from "./Spkb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports